/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraAutocompleteSuggestionSchema = z.object({
  displayName: z.string(),
  value: z.string(),
});
